import { c as _c } from "react/compiler-runtime";
import './skeleton-image.scss';
import type { CSSProperties } from 'react';
import { cn } from '../../utils/helpers.ts';
type SkeletonImageProps = {
  width?: string | number;
  height?: string | number;
  borderRadius?: string | number;
  style?: CSSProperties;
  className?: string;
};

/**
 * A skeleton placeholder that mimics the blurred placeholder shown by the
 * Image component while an image loads. Use this in skeleton screens where
 * an image will eventually appear, so the visual transition is seamless.
 */
export const SkeletonImage: React.FC<SkeletonImageProps> = t0 => {
  const $ = _c(11);
  const {
    width,
    height,
    borderRadius,
    style,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("SkeletonImage", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== borderRadius || $[3] !== height || $[4] !== style || $[5] !== width) {
    t2 = {
      width,
      height,
      borderRadius,
      ...style
    };
    $[2] = borderRadius;
    $[3] = height;
    $[4] = style;
    $[5] = width;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="SkeletonImage__blur" />;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t2) {
    t4 = <div className={t1} style={t2}>{t3}</div>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};